// extracted by mini-css-extract-plugin
export default {"text":"Categories_text__x29sV","table":"Categories_table__1qoCQ","down":"Categories_down__om48l"};